<template lang="html">
  <div class="content">
    <clueFilter :type="2" v-on:filterData="getFilters" />
    <div class="list">
      <div class="handles"></div>
      <listItem :list="list" :type="2" :sort="true" v-on:getSort="getFilters" :showCreate="showCreate" />
      <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total" />
    </div>
  </div>
</template>

<script>
import clueFilter from '@components/clueFilter'
import listItem from '@components/listItem'
import common from '@common/common'
import {apis} from '@common/config'
import pages from '@components/pages'

export default {
  components: { clueFilter, listItem, pages },
  data() {
    return {
      list: null,
      filterOptions: {},
      searchOptions: {},
      page: {
        pageIndex: 1,
        pageCount: 0,
        pageSize: 10,
        total: 0
      },
      showCreate: false
    }
  },
  methods: {
    getFilters(data) {
      // 获取过滤条件数据
      // this.filterOptions = data
      this.filterOptions = Object.assign({}, this.filterOptions, data)
      this.page.pageIndex = 1
      this.getList()
    },
    getList() {
      // 获取列表数据
      const id = this.$route.params.id
      const info = {
        idstring: id,
        pagesize: this.page.pageSize,
        page: this.page.pageIndex,
        sort_by: '',
        search_option: '',
        key_words: '',
        source_pid: '',
        source_sid: '',
        days: '',
        tags: '',
        has_file: ''
      }
      Object.assign(info, this.searchOptions, this.filterOptions)

      common.myFetch(apis.channelClue, info)
      .then((res) => {
        if (res) {
          this.list = res.list
          this.generateSearchs(res.params.top_search.option.list)
          this.$set(this.page, 'pageCount', common.calculatePage(res.page.row_count - 0, this.page.pageSize))
          this.$set(this.page, 'total', res.page.row_count - 0)
          this.showCreate = res.has_add_role
        }
      })
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }
      this.postSearch(filterData)
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d
      this.page.pageIndex = 1
      this.getList()
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit('filterData', data)
    }
  },
  mounted() {
    const selectedTag = this.$route.params.tag || ''
    this.filterOptions.tags = selectedTag

    this.getList()
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/global.less';

  .list {
    .boxOuter;
    padding-bottom: 50px;
  }
</style>
